import { GetProfileResponse } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

type TGetLogoResponse = {
  data: {
    affiliate_tag: string;
    logo_file_name: string;
    introducer_account_config_id: number;
  }[];
  max_records: number;
  next: number | null;
  prev: number | null;
  total_pages: number;
};
const GET_LOGO_URL =
  '/api/v3/introducer_account_config/?filter_key=logo_file_name__not__isempty&filter_value=true&filter_key=superseded_at__gt&filter_value=CURRENT_DATETIME&field=affiliate_tag&field=logo_file_name&page=1&page_size=100';

export const useGetLogoUrls = (
  user_type?: GetProfileResponse['data']['user_type'],
) => {
  const fetchLogos = async () => {
    const response = await fetch(GET_LOGO_URL);

    return response.json() as Promise<TGetLogoResponse>;
  };

  const { data, isPending } = useQuery({
    queryKey: ['fetchGetLogos'],
    queryFn: fetchLogos,
    enabled: user_type === 'staff',
  });

  return { logosData: data, isLoading: isPending };
};
